import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    titleCard: {
      color: palette.darkGray,
      fontWeight: 600,
      fontSize: 14,
      marginLeft: 48,
    },
    marginContentCard: {
      marginLeft: 40,
      marginBottom: 40,
    },
    iconStyleAdmin: {
      color: palette.iconYellow,
    },
    iconStyleSuperAdmin: {
      color: palette.navSuperAdminActions,
    },
    iconStyleOperator: {
      color: palette.navOperatorActions,
    },
  });
